export default __webpack_public_path__ + "static/media/allcategories.7a89d599.svg";